/** Brief delay so the End Conversation button can show a pressed/selected state after a verbal stop. */
export const END_CONVERSATION_ACK_MS = 220;

/**
 * Highlight End Conversation, then run the same teardown as the button click.
 * Stop runs immediately; the pressed state clears after a brief delay.
 *
 * @param {(value: boolean) => void} setAcknowledged
 * @param {() => void} stopFn
 */
export function scheduleVerbalEndConversationAck(setAcknowledged, stopFn) {
  setAcknowledged(true);
  stopFn();
  window.setTimeout(() => {
    setAcknowledged(false);
  }, END_CONVERSATION_ACK_MS);
}
